import angular from 'angular';
import { Information } from './information/information.component';
import { Configuration } from './configuration/configuration.component';
import { PaymentMethod } from './paymentMethod/paymentMethod.component';
export const paymentTabsComponents = angular
    .module('paymentTabsComponents', [])
    .component('informationTab', Information)
    .component('configurationTab', Configuration)
    .component('paymentMethodTab', PaymentMethod)
    .name;
